import { SET_PAGE_TITLE } from "constants/ActionTypes";

const currentUrl = window.location.href;
const lang = localStorage.getItem("i18nextLng");
const initialValue = (currentUrl) => {
  switch (currentUrl) {
    case "http://localhost:3000/app/groups": {
      return lang === "fa" ? "گروه‌ها" : "Groups";
    }
    case "http://localhost:3000/app/invoice-page": {
      return lang === "fa" ? "فاکتورها" : "Invoices";
    }
    case "http://localhost:3000/app/transaction-page": {
      return lang === "fa" ? "تراکنش ها" : "Transaction";
    }
    case "http://localhost:3000/app/map": {
      return lang === "fa" ? "دیسپچینگ" : "Dispatch";
    }
    case "http://localhost:3000/app/tenant": {
      return lang === "fa" ? "زیرمجموعه‌ها" : "Tenants";
    }
    case "http://localhost:3000/app/profile-page": {
      return lang === "fa" ? "پروفایل" : "Profile";
    }
    case "http://localhost:3000/app/chat": {
      return lang === "fa" ? "گفتگوها" : "Chat";
    }
    case "http://localhost:3000/app/missions": {
      return lang === "fa" ? "مأموریت‌ها" : "Missions";
    }
    case "http://localhost:3000/app/notifications": {
      return lang === "fa" ? "اعلان‌ها" : "Notifications";
    }
    default:
      return lang === "fa" ? "کاربران" : "Users";
  }
};
const INIT_STATE = initialValue(currentUrl);

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PAGE_TITLE: {
      return action.payload;
    }
    default:
      return state;
  }
};
